//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { subtract, multiply, round, assign, cloneDeep, getSeconds, flashAnimate, dealPosiData, langFn } from '~/assets/js/utils.js'
export default {
  components: {
    'two-bar': () => import('~/components/home/sentiment/twoBar.vue'),
    'mobile-tab': () => import('~/components/common/mobileTab.vue')
  },
  props: {
    emo: { // 多空情绪列表
      type: Array, default: () => []
    },
    posi: { // 持仓分布列表
      type: Array, default: () => []
    },
    vps: { // VPS版本列表
      type: Array, default: () => []
    }
  },
  data () {
    return {
      // 多空情绪
      optionList: [{ name: 'EUR/USD' }, { name: 'GBP/USD' }, { name: 'AUD/USD' }, { name: 'NZD/USD' }, { name: 'USD/JPY' }, { name: 'USD/CAD' }, { name: 'USD/CHF' }, { name: 'XAU/USD' }], // 下拉选项列表
      moodList: [], // 处理后的列表项
      // 持仓分布
      selectedPosi: '', // 下拉选项选中项
      posiList: [], // 处理后的列表项
      // EA VPS版本
      vpsList: [], // 列表项
      // 多空情绪弹框
      showEmoDialog: false, // 是否展示弹框
      emoSelectedImg: '', // 交易商图片
      emoSelectedName: '', // 交易商名称
      emoTab: 1, // tab选中项
      emoApi: [], // 接口返回的列表项
      holdList: [], // 处理后的列表项
      updateTime: getSeconds(), // 更新时间
      // 持仓分布弹框
      showPosiDialog: false, // 是否展示弹框
      dropChecked: 0, // 下拉选项选中项
      posiObj: { // 页面数据
        sellWinXScale: [],
        sellWinYScaleArray: [],
        buyWinXScale: [],
        buyWinYScaleArray: [],
        sellLossXScale: [],
        sellLossYScaleArray: [],
        buyLossXScale: [],
        buyLossYScaleArray: [],
        x_coordinate: [],
        y_coordinate: [],
        cutTxt: ''
      }
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store?.state?.isMobile
    },
    // 当前屏幕的宽度
    equipWidth () {
      return this.$store?.state?.screenWidth || 0
    },
    // 多空情绪——柱子文本展示最小值
    minNum () {
      return this.equipWidth >= 1200 ? 30 : (this.equipWidth >= 1000 ? 25 : (this.equipWidth >= 800 ? 32 : 30))
    },
    // 持仓分布——图表配置项公用部分
    commonConf () {
      return (isRotate = false) => ({
        tooltip: {
          backgroundColor: 'rgba(0,0,0,0.7)',
          borderColor: 'rgba(0,0,0,0.2)',
          textStyle: {
            color: '#FFFFFF'
          },
          formatter: params => `<div class=${isRotate ? 'sides-pop-rotate' : ''}><span class="sides-dot" style="background:${params.color};"></span>price：${params.name}<br /><span class="sides-dot" style="background:${params.color};"></span>rate：${Math.abs(params.data)}%</div>`
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        xAxis: {
          type: 'value',
          position: 'bottom',
          splitLine: { show: false },
          axisLabel: {
            formatter: params => Math.abs(params),
            color: '#333333'
          }
        },
        yAxis: {
          type: 'category',
          position: 'left',
          max: 14,
          axisTick: { show: false },
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: false }
        },
        series: [{
          type: 'bar',
          barWidth: 10,
          label: { show: false }
        }]
      })
    }
  },
  created () {
    // 多空情绪
    this.selectedPosi = this.optionList[0]?.name?.replace('/', '')
    this.moodList = this.dealMoodData(cloneDeep(this.emo))
    // 持仓分布
    this.posiList = cloneDeep(this.posi)
    // EA VPS版本
    let newArr = cloneDeep(this.vps)
    newArr = newArr?.map((item) => {
      item.osInfo = (typeof item.osInfo !== 'string' ? item.osInfo : item?.osInfo?.split('/') || [])
      return item
    })
    // console.log(newArr)
    this.vpsList = newArr.slice(0, 3)
  },
  mounted () {
    this.flickerTimer = setTimeout(this.flashAniFn, 5000)
  },
  beforeDestroy () {
    clearTimeout(this.flickerTimer) // 清除延时器
    this.closeEmoFn()
  },
  methods: {
    // 多空情绪——下拉选项改变时
    async changeMoodFn ({ name = '' }) {
      const symbol = name?.replace('/', '')
      try {
        const { list = [] } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/longShortRate' }, { symbol, languageCode: langFn(this.currLangCode()) })
        this.moodList = this.dealMoodData(cloneDeep(list || []))
        clearTimeout(this.flickerTimer)
        this.flickerTimer = setTimeout(this.flashAniFn, 5000)
      } catch (err) {}
    },
    // 多空情绪——处理接口返回的数据
    dealMoodData (arr = []) {
      arr?.forEach((item) => {
        item.red = round(multiply(item.longNumRate || 0, 100), 2)
        item.green = round(multiply(item.shortNumRate || 0, 100), 2)
        item.active = false
      })
      return arr
    },
    // 多空情绪——高亮某几个横条
    flashAniFn () {
      clearTimeout(this.flickerTimer)
      this.moodList = flashAnimate(this.moodList)
      this.flickerTimer = setTimeout(this.flashAniFn, 5000)
    },
    // 多空情绪弹框——打开弹框
    async openEmoFn (obj = {}) {
      const { brokerId = '', brokerIcon = '', brokerName = '' } = obj
      if (brokerId?.toLowerCase() == 'all') return false
      if (this.isM) { // 手机端不展示弹框，而是跳转页面
        window?.open(`/${this.currLangCode()}/data/holdpositiondetails.html?id=${brokerId}&icon=${brokerIcon}&name=${brokerName}`)
        return true
      }
      this.emoSelectedImg = brokerIcon
      this.emoSelectedName = brokerName
      this.showEmoDialog = true
      try {
        const { tianyancenter = {} } = await this.$api.home.sentimentCurrencyClient({ HttpMethod: 'post', Routes: 'tianyancenter$dkqx' }, { broker_id: brokerId })
        this.emoApi = (tianyancenter?.dkqx?.data?.data || [])
        this.updateTime = getSeconds()
        this.holdList = this.dealEmoData(this.emoApi, subtract(this.emoTab, 1))
        this.lightTimer = setTimeout(this.twinkleFn, 5000)
      } catch (err) {}
    },
    // 多空情绪弹框——切换tab
    emoTabsFn (value = 1) {
      this.emoTab = value
      this.holdList = this.dealEmoData(this.emoApi, subtract(value, 1))
      clearTimeout(this.lightTimer)
      this.lightTimer = setTimeout(this.twinkleFn, 5000)
    },
    // 多空情绪弹框——处理接口返回的数据
    dealEmoData (arr = [], tabIdx = 0) {
      const resultArr = []
      arr?.forEach((item, index) => {
        item.red = round(multiply(item[tabIdx < 1 ? 'longNumRate' : 'longLotsRate'], 100), 2)
        item.green = round(multiply(item[tabIdx < 1 ? 'shortNumRate' : 'shortLotsRate'], 100), 2)
        // assign(item, { id: String(index + 1), nameEn: item.symbol, label: (this.currLangCode() != 'zh-cn' ? `${key}` : `${key}<br/>${obj.name}`), active: false })
        assign(item, { id: String(index + 1), nameEn: item.symbol, label: item.symbol, active: false })
        resultArr.push(item)
      })
      return resultArr
    },
    // 多空情绪弹框——高亮某几个横条
    twinkleFn () {
      clearTimeout(this.lightTimer)
      this.holdList = flashAnimate(this.holdList)
      this.updateTime = getSeconds() // 更新时间
      this.lightTimer = setTimeout(this.twinkleFn, 5000)
    },
    // 多空情绪弹框——关闭弹框
    closeEmoFn () {
      this.showEmoDialog = this.showPosiDialog = false
      this.emoTab = 1 // 恢复到第一个tab
      this.dropChecked = this.emoApi.length = this.holdList.length = 0 // 清空数组、持仓分布下拉选择框恢复为第一个选中
      clearTimeout(this.lightTimer) // 清除延时器
      clearTimeout(this.againTimer)
      this.upLeft?.dispose() // 销毁图表
      this.upRight?.dispose()
      this.downLeft?.dispose()
      this.downRight?.dispose()
      this.upLeft = this.upRight = this.downLeft = this.downRight = null
    },
    // 持仓分布——下拉选项改变时
    async changePosiFn ({ name = '', index = 0 }) {
      const symbol = name?.replace('/', '')
      this.selectedPosi = symbol
      this.dropChecked = index
      try {
        const { list = [] } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/holdposition' }, { symbol, languageCode: langFn(this.currLangCode()) })
        this.posiList = cloneDeep(list || [])
      } catch (err) {}
    },
    // 持仓分布——绿涨红跌文字/数字
    arrowFn (value = 0) {
      value = String(value)?.replace('%', '') || '0'
      const resNum = this.riseFn(value)
      return resNum > 0 ? 'down-txt' : (resNum < 0 ? 'raise-txt' : '')
    },
    // 持仓分布——为正数增加“+”号
    addPlusSymbol (value = 0) {
      const isPositiveNum = (String(value)?.replace('%', '') || '0') > 0 // 判断是否为正数
      return isPositiveNum ? `+${value}` : value
    },
    // 持仓分布弹框——打开弹框
    openPosiFn (value = '') {
      if (value?.toLowerCase() == 'all') return false
      if (this.isM) { // 手机端不展示弹框，而是跳转页面
        window?.open(`/${this.currLangCode()}/data/position.html?symbol=${this.selectedPosi}`)
        return true
      }
      this.showPosiDialog = true
      this.$nextTick(() => {
        this.changeSymbolFn({ name: this.selectedPosi })
      })
    },
    // 持仓分布弹框——下拉选项改变时
    async changeSymbolFn ({ name = '' }) {
      const symbol = name?.replace('/', '')
      try {
        const { OpenOrderRate: openRate = {}, PriceStepList: priceStep = [] } = await this.$api.holdPosi.holdDistributionClient({ symbol })
        this.posiObj = dealPosiData(openRate, priceStep, 4)
        clearTimeout(this.againTimer)
        this.setBar1(this.posiObj)
      } catch (err) {}
    },
    // 持仓分布弹框——绘制左上角的柱状图
    setBar1 (data = {}) {
      if (!this.upLeft) this.upLeft = this.$echarts.init(document.getElementById('up-left'))
      this.upLeft?.clear()
      const option = cloneDeep(this.commonConf())
      assign(option.tooltip, {
        position: point => [point[0], point[1]]
      })
      assign(option.xAxis, {
        min: data?.x_coordinate[0],
        max: 0
      })
      assign(option.yAxis, {
        position: 'right',
        data: data?.sellWinYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#EB4654' : '#1FBB95' },
        data: data?.sellWinXScale
      })
      this.upLeft?.setOption(option)
      this.setBar2(data)
    },
    // 持仓分布弹框——绘制右上角的柱状图
    setBar2 (data = {}) {
      if (!this.upRight) this.upRight = this.$echarts.init(document.getElementById('up-right'))
      this.upRight?.clear()
      const option = cloneDeep(this.commonConf())
      assign(option.tooltip, {
        confine: true
      })
      assign(option.xAxis, {
        min: 0,
        max: Math.abs(data?.x_coordinate[0])
      })
      assign(option.yAxis, {
        data: data?.buyLossYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#1FBB95' : '#EB4654' },
        data: data?.buyLossXScale
      })
      this.upRight?.setOption(option)
      this.setBar3(data)
    },
    // 持仓分布弹框——绘制左下角的柱状图
    setBar3 (data = {}) {
      if (!this.downLeft) this.downLeft = this.$echarts.init(document.getElementById('down-left'))
      this.downLeft?.clear()
      const option = cloneDeep(this.commonConf(true))
      assign(option.tooltip, {
        confine: true
      })
      assign(option.xAxis, {
        min: data?.x_coordinate[0],
        max: 0
      })
      assign(option.yAxis, {
        data: data?.buyWinYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#EB4654' : '#1FBB95' },
        data: data?.buyWinXScale
      })
      this.downLeft?.setOption(option)
      this.setBar4(data)
    },
    // 持仓分布弹框——绘制右下角的柱状图
    setBar4 (data = {}) {
      if (!this.downRight) this.downRight = this.$echarts.init(document.getElementById('down-right'))
      this.downRight?.clear()
      const option = cloneDeep(this.commonConf(true))
      assign(option.xAxis, {
        min: 0,
        max: Math.abs(data?.x_coordinate[0])
      })
      assign(option.yAxis, {
        position: 'right',
        data: data?.sellLossYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#1FBB95' : '#EB4654' },
        data: data?.sellLossXScale
      })
      this.downRight?.setOption(option)
      this.againTimer = setTimeout(() => {
        this.setBar1(data)
        this.updateTime = getSeconds() // 当前时间
      }, 10000)
    }
  }
}
